<div class="padding-11" style="overflow-x: auto;">
    <div class="editSets" fxLayout="column">
        <calsoft-list (filterChangeColumn)="onFilterChangeColumn($event)" 
        (filterChange)="onFilterChange($event)" name="Audit" [columns]="columns"
            style="margin-bottom: 0px;">

            <div id="responsieTable" class="container">
                <div [ngClass]="auditList.length>=5?'minimum':'none'">
                    <table class="rwd-table">
                        <tbody>
                            <tr>
                                <th>Field Name</th>
                                <th>Old Value</th>
                                <th>New Value</th>
                                <th>Last Update By</th>
                                <th>Last Update On</th>
                                <th>Update Via</th>
                              </tr>

                            <tr *ngFor="let item of auditList;let i=index">
                          
                                <td  data-th="Field Name">
                                    {{item.key}}
                                   </td>
                                   <td data-th="Old Value">
                                     {{item.oldValue}}
                                   </td>
                                   <td data-th="New Value">
                                     {{item.newValue}}
                                   </td>
                                   <td data-th="Last Update By">
                                     {{item.createdBy}}
                                   </td>
                                   <td data-th="Last Update On">
                                     {{item.updatedDate | calsoftDate}}
                                   </td>
                                   <td data-th="Update Via">
                                     {{item.updatedVia}}
                                   </td>
                            </tr>
                        </tbody>
                    </table>
                    <div fxLayout="row" *ngIf="auditList.length==0" fxLayoutAlign="center center">
                        <span>No Records Found</span>
                    </div>
                </div>
            </div>
              
            <div fxLayout="row" class="pager" fxLayoutAlign="end center" fxLayoutGap="5px">
                <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
                    [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue">
                </mat-paginator>
            </div>
        </calsoft-list>
    </div>
 
</div>